module.exports = __webpack_public_path__ + "img/PLW.1e38c05a.svg";